
const $ = require('jquery');

function isPromiseAlike (x) {
	return typeof x === 'object' && typeof x.then === 'function';
}

module.exports = function coerceToJqueryDeferred (x) {
	if (isPromiseAlike(x)) {
		const dfr = $.Deferred();
		x.then(dfr.resolve, dfr.reject);
		return dfr.promise();
	}
	return $.when(x);
	
};

